var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c(
        "nav",
        {
          staticClass:
            "navbar navbar-lg navbar-expand-lg navbar-dark bg-primary"
        },
        [
          _c(
            "div",
            { staticClass: "container-fluid" },
            [
              _c(
                "router-link",
                { staticClass: "navbar-brand", attrs: { to: "/user/landing" } },
                [_vm._v("\n        Scales\n      ")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-white dropdown-toggle mr-2",
                    attrs: {
                      type: "button",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false"
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("navbar.language")) +
                        "\n        "
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "dropdown-menu" }, [
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.changeLanguage("en")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("languageChoice.English")) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.changeLanguage("zh")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("languageChoice.Chinese")) +
                          "\n          "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "dropdown-item",
                      on: {
                        click: function($event) {
                          return _vm.changeLanguage("jp")
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("languageChoice.Japanese")) +
                          "\n          "
                      )
                    ]
                  )
                ])
              ])
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("main", { staticClass: "main", attrs: { role: "main" } }, [
        _c("div", { staticClass: "py-5 bg-light" }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "col-md-12 p-0" }, [
              _c(
                "div",
                {
                  staticClass:
                    "mt-4 col-12 col-sm-9 col-md-7 col-lg-6 pl-0 pr-0"
                },
                [
                  _c("ul", { staticClass: "nav nav-tabs wizard pl-0 pr-0" }, [
                    _c(
                      "li",
                      {
                        class: {
                          active: _vm.step === 1,
                          completed: _vm.step > 1
                        }
                      },
                      [_c("a", [_vm._v(_vm._s(_vm.$t("RegisterPage.Terms")))])]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: {
                          active: _vm.step === 2,
                          completed: _vm.step > 2
                        }
                      },
                      [_c("a", [_vm._v(_vm._s(_vm.$t("RegisterPage.Input")))])]
                    ),
                    _vm._v(" "),
                    _c(
                      "li",
                      {
                        class: {
                          active: _vm.step === 3,
                          completed: _vm.step > 3
                        }
                      },
                      [
                        _c("a", [
                          _vm._v(_vm._s(_vm.$t("RegisterPage.Confrim")))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("li", { class: { active: _vm.step >= 4 } }, [
                      _c("a", [_vm._v(_vm._s(_vm.$t("RegisterPage.Complete")))])
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.step === 1
                ? _c("div", [
                    _c("div", { staticClass: "card mt-4" }, [
                      _c("div", { staticClass: "card-body pb-2 pr-0" }, [
                        _c("h4", { staticClass: "text-center" }, [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.$t("RegisterPage.center")) +
                              "\n                "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "privacyPolicy-scroll-bar" }, [
                          _c(
                            "div",
                            { staticClass: "pt-4 col-10 offset-1 p-0" },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t(
                                      "privacyPolicy.registerPrivacyPolicy"
                                    )
                                  )
                                }
                              })
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group mt-4" }, [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c("div", { staticClass: "input-group-text" }, [
                          _c("input", {
                            attrs: {
                              id: "confirm",
                              type: "checkbox",
                              "aria-label": "Checkbox for following text input"
                            },
                            domProps: { checked: _vm.confirmed },
                            on: {
                              click: function($event) {
                                _vm.confirmed = !_vm.confirmed
                              }
                            }
                          })
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "form-control",
                          staticStyle: { width: "auto", flex: "none" },
                          attrs: {
                            type: "text",
                            "aria-label": "Text input with checkbox",
                            for: "confirm"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("RegisterPage.Confirm")))]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.step === 2 || _vm.step == 3
                ? _c("div", [
                    _c("div", { staticClass: "card mt-4 pt-3 pb-3" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "form",
                          {
                            staticClass: "demo-ruleForm pt-4 needs-validation",
                            attrs: { "label-width": "0px", novalidate: "" }
                          },
                          [
                            _c("h5", { staticClass: "card-title pt-3 pl-3 " }, [
                              _vm._v(
                                _vm._s(_vm.$t("Registerform.UserInforTitle"))
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "nav",
                              { staticClass: "navbar navbar-light col-12" },
                              [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "emailAddress" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.$t("Registerform.Email"))
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c("input", {
                                          staticClass: "form-control",
                                          attrs: {
                                            id: "emailAddress",
                                            type: "email",
                                            readonly: ""
                                          },
                                          domProps: { value: _vm.email }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "name" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Registerform.MyName"))
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 col-md-8" }, [
                                _c("div", { staticClass: "col-12 p-0" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.userInfo.user_name,
                                        expression: "userInfo.user_name"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      id: "name",
                                      "aria-label": "username",
                                      "aria-describedby": "basic-addon2",
                                      readonly: _vm.step === 3,
                                      required: ""
                                    },
                                    domProps: { value: _vm.userInfo.user_name },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.userInfo,
                                          "user_name",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "invalid-feedback" },
                                    [
                                      _vm._v(
                                        "\n                          " +
                                          _vm._s(
                                            _vm.$t("Registerform.MyNameTips")
                                          ) +
                                          "\n                        "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "telephone" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Registerform.MyTelephone"))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-sm border-0",
                                    attrs: {
                                      tabindex: "0",
                                      role: "button",
                                      "data-toggle": "popover",
                                      "data-trigger": "focus",
                                      title: _vm.$t("Registerform.MyTelephone"),
                                      "data-content": _vm.$t(
                                        "Registerform.TelephoneTips"
                                      )
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../static/img/info.svg")
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12 p-0" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.user_telephone,
                                            expression:
                                              "userInfo.user_telephone"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "telephone",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3,
                                          required: ""
                                        },
                                        domProps: {
                                          value: _vm.userInfo.user_telephone
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "user_telephone",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "invalid-feedback" },
                                        [
                                          _vm._v(
                                            "\n                          " +
                                              _vm._s(
                                                _vm.$t(
                                                  "Registerform.TelephoneTips1"
                                                )
                                              ) +
                                              "\n                        "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "language" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Registerform.language"))
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12 p-0" },
                                    [
                                      _c(
                                        "select",
                                        {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.userInfo.language_code,
                                              expression:
                                                "userInfo.language_code"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            id: "language",
                                            "aria-describedby": "basic-addon2",
                                            disabled: _vm.step === 3
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$selectedVal = Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function(o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function(o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                              _vm.$set(
                                                _vm.userInfo,
                                                "language_code",
                                                $event.target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "option",
                                            { attrs: { value: "en" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "languageChoice.English"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "jp" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "languageChoice.Japanese"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "option",
                                            { attrs: { value: "zh" } },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "languageChoice.Chinese"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("h5", { staticClass: "card-title pt-3 pl-3 " }, [
                              _vm._v(_vm._s(_vm.$t("Registerform.FairFX")))
                            ]),
                            _vm._v(" "),
                            _c(
                              "nav",
                              { staticClass: "navbar navbar-light col-12" },
                              [
                                _c("div", { staticClass: "col-12 col-md-4" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "navbar-brand",
                                      attrs: { for: "fairFX" }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("Registerform.FairFXNumber")
                                        )
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "form-inline col-12 col-md-8"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "input-group col-12 p-0" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.userInfo.fairfx_number,
                                              expression:
                                                "userInfo.fairfx_number"
                                            }
                                          ],
                                          staticClass: "form-control",
                                          attrs: {
                                            id: "fairFX",
                                            type: "text",
                                            readonly: _vm.step === 3
                                          },
                                          domProps: {
                                            value: _vm.userInfo.fairfx_number
                                          },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.userInfo,
                                                "fairfx_number",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  ]
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("h5", { staticClass: "card-title pt-3 pl-3 " }, [
                              _vm._v(_vm._s(_vm.$t("Registerform.BankAccount")))
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "accountHolderName" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Registerform.accountHolderName")
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-sm border-0",
                                    attrs: {
                                      tabindex: "0",
                                      role: "button",
                                      "data-toggle": "popover",
                                      "data-trigger": "focus",
                                      title: _vm.$t(
                                        "Registerform.accountHolderName"
                                      ),
                                      "data-content": _vm.$t(
                                        "Registerform.accountHolderNameTips"
                                      )
                                    }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../../static/img/info.svg")
                                      }
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12 p-0" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.account_name,
                                            expression: "userInfo.account_name"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "accountHolderName",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: {
                                          value: _vm.userInfo.account_name
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "account_name",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "firstName" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Registerform.firstName"))
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12 p-0" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.first_name,
                                            expression: "userInfo.first_name"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "firstName",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: {
                                          value: _vm.userInfo.first_name
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "first_name",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "lastName" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Registerform.lastName"))
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12 p-0" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.last_name,
                                            expression: "userInfo.last_name"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "lastName",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: {
                                          value: _vm.userInfo.last_name
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "last_name",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "street" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Registerform.myResidence"))
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12 p-0" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.account_street,
                                            expression:
                                              "userInfo.account_street"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "street",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: {
                                          value: _vm.userInfo.account_street
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "account_street",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "city" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Registerform.mycity"))
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12 p-0" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.account_city,
                                            expression: "userInfo.account_city"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "city",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: {
                                          value: _vm.userInfo.account_city
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "account_city",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "postcode" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Registerform.myPostalCode")
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12 p-0" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.userInfo.account_postcode,
                                            expression:
                                              "userInfo.account_postcode"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "postcode",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: {
                                          value: _vm.userInfo.account_postcode
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "account_postcode",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "country" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Registerform.mycountry"))
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12 p-0" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.account_country,
                                            expression:
                                              "userInfo.account_country"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "country",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: {
                                          value: _vm.userInfo.account_country
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "account_country",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "accountNumber" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Registerform.accountNumber")
                                      )
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12 p-0" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.account_number,
                                            expression:
                                              "userInfo.account_number"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "accountNumber",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: {
                                          value: _vm.userInfo.account_number
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "account_number",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "bankName" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Registerform.bankName"))
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12 p-0" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.bank_name,
                                            expression: "userInfo.bank_name"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "bankName",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: {
                                          value: _vm.userInfo.bank_name
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "bank_name",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "bankStreet" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Registerform.bankStreet"))
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12 p-0" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.bank_street,
                                            expression: "userInfo.bank_street"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "bankStreet",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: {
                                          value: _vm.userInfo.bank_street
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "bank_street",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "bankCountry" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Registerform.bankCountry"))
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12 p-0" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.bank_country,
                                            expression: "userInfo.bank_country"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "bankCountry",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: {
                                          value: _vm.userInfo.bank_country
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "bank_country",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "bankSWIFT" }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("Registerform.bankSWIFT"))
                                    )
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group p-0 col-12" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.bank_swift,
                                            expression: "userInfo.bank_swift"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        staticStyle: {
                                          "border-bottom-right-radius":
                                            "0.35rem",
                                          "border-top-right-radius": "0.35rem"
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "bankSWIFT",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: {
                                          value: _vm.userInfo.bank_swift
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "bank_swift",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "navbar-brand ml-3",
                                          attrs: { for: "routing" }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("Registerform.routing")
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.bank_routing,
                                            expression: "userInfo.bank_routing"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        staticStyle: {
                                          "border-bottom-left-radius":
                                            "0.35rem",
                                          "border-top-left-radius": "0.35rem"
                                        },
                                        attrs: {
                                          type: "text",
                                          id: "routing",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: {
                                          value: _vm.userInfo.bank_routing
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "bank_routing",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "IBAN" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Registerform.IBAN")))]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "input-group col-12 p-0" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.account_iban,
                                            expression: "userInfo.account_iban"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          type: "text",
                                          id: "IBAN",
                                          "aria-describedby": "basic-addon2",
                                          readonly: _vm.step === 3
                                        },
                                        domProps: {
                                          value: _vm.userInfo.account_iban
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.userInfo,
                                              "account_iban",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("nav", { staticClass: "navbar col-12" }, [
                              _c("div", { staticClass: "col-12 col-md-4" }, [
                                _c(
                                  "label",
                                  {
                                    staticClass: "navbar-brand",
                                    attrs: { for: "BACS" }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("Registerform.BACS")))]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "form-inline col-12 col-md-8" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "custom-control custom-checkbox p-0 pl-4"
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.userInfo.bank_bacs_sepa,
                                            expression:
                                              "userInfo.bank_bacs_sepa"
                                          }
                                        ],
                                        staticClass: "custom-control-input",
                                        attrs: {
                                          id: "BACS",
                                          type: "checkbox",
                                          "aria-label":
                                            "Checkbox for following text input",
                                          disabled: _vm.step === 3
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.userInfo.bank_bacs_sepa
                                          )
                                            ? _vm._i(
                                                _vm.userInfo.bank_bacs_sepa,
                                                null
                                              ) > -1
                                            : _vm.userInfo.bank_bacs_sepa
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a =
                                                _vm.userInfo.bank_bacs_sepa,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.userInfo,
                                                    "bank_bacs_sepa",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.userInfo,
                                                    "bank_bacs_sepa",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.userInfo,
                                                "bank_bacs_sepa",
                                                $$c
                                              )
                                            }
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("label", {
                                        staticClass: "custom-control-label",
                                        attrs: { for: "BACS" }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.step === 4
                ? _c("div", [
                    _c("div", { staticClass: "p-0 card mt-4 pt-3 pb-3" }, [
                      _c(
                        "div",
                        { staticClass: "p-5 text-center" },
                        [
                          _c("p", [
                            _vm._v(_vm._s(_vm.$t("Registerform.successful"))),
                            _c("br"),
                            _vm._v(
                              _vm._s(_vm.$t("Registerform.logininterface"))
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "router-link",
                            {
                              staticClass: "btn btn-lg btn-primary",
                              attrs: { to: "/user/login" }
                            },
                            [_vm._v(_vm._s(_vm.$t("Registerform.Login")))]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row justify-content-end mt-4 col-12 pr-0" },
              [
                _c("div", { staticClass: "col-6" }, [
                  _vm.step <= 3 && _vm.step > 1
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-outline-secondary mr-3 col-5 col-md-4 col-lg-2",
                          attrs: { disabled: _vm.step < 2 },
                          on: {
                            click: function($event) {
                              _vm.step--
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("Registerform.Backbtn")))]
                      )
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6 text-right pr-0" }, [
                  _vm.step < 3
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { disabled: !_vm.confirmed },
                          on: { click: _vm.next }
                        },
                        [_vm._v(_vm._s(_vm.$t("RegisterPage.Next")))]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.step === 3
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          on: { click: _vm.regist }
                        },
                        [_vm._v(_vm._s(_vm.$t("Registerform.Regist")))]
                      )
                    : _vm._e()
                ])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("copyright")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11ffffd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11ffffd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/register.vue
// module id = null
// module chunks = 